<footer class="footer">
  <div class="footer-content">
      <p>&copy; 2024 Lore par Esetan, Site par AngelsMari. Tous droits réservés.
      <a href="/politique-confidentialite" class="footer-link">Politique de confidentialité</a>
      <span>|</span>
      <a href="/mentions-legales" class="footer-link">Mentions Légales</a></p>
  </div>
</footer>